import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { TaraPopover } from '../components/features/Tara';
import { getTaraHasCuratedTickets } from '../reducers/tara/hasCuratedTickets';
import { getTaraHasMadeIntroduction } from '../reducers/tara/hasMadeIntroduction';
import { getEventsById } from '../reducers/events/byId';
import { actions as analyticsActions } from '../actions/analytics';

class TaraPopoverContainer extends React.PureComponent {
  render() {
    return (
      <TaraPopover {...this.props} />
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  currentEvent: getEventsById(state)[state.location.payload.id] || {},
  hasCuratedTickets: getTaraHasCuratedTickets(state),
  hasMadeIntroduction: getTaraHasMadeIntroduction(state),
  ...ownProps,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  ...analyticsActions,
}, dispatch);

export default connect(mapStateToProps,mapDispatchToProps)(TaraPopoverContainer);



// WEBPACK FOOTER //
// ./src/containers/TaraPopoverContainer.js